import api from "app/api";
import { Options } from "common";

export interface PartnerFeedItem {
  id: number;
  title: string;
  description?: string;
  file_id?: number;
  account_manager_id?: number;
  file?: {
    id: number;
    name: string;
    path: string;
    extension: string;
    mime_type: string;
    size: number;
  };
  created_at?: string;
  updated_at?: string;
}

export type PartnerFeedOptions = Options<"role" | "status">;

export function getPartnerFeedService(scope?: any) {
  return api.getService<PartnerFeedItem, PartnerFeedItem, PartnerFeedOptions>(
    "partner-feeds",
    {
      scope,
      //params goes here
    },
  );
}
